import PropTypes from 'prop-types'
import { Box, Card, Chip, Typography } from '@mui/material'
import { BADGE_TIERS, formatDuration } from '../Utils/utils'
import { metricDataPropType } from '../Utils/types'

export default function FitnessStatTile({ label, colour, data }) {
  const { value, target } = data
  const percentage = target > 0 ? Math.round((value / target) * 100) : 0
  const isTalkTime = label?.toLowerCase() === 'talk time'
  const displayValue = isTalkTime ? formatDuration(value) : value
  const displayTarget = isTalkTime ? formatDuration(target) : target

  const badge =
    BADGE_TIERS.find(({ minPercent }) => percentage >= minPercent) ?? null

  return (
    <Card
      sx={{
        p: 1.5,
        bgcolor: 'action.hover',
        color: 'text.primary',
        borderRadius: 3,
      }}
    >
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Box display="flex" alignItems="center" gap={1}>
          <Box
            sx={{
              width: 6,
              height: 6,
              borderRadius: '50%',
              bgcolor: colour,
            }}
          />

          <Typography variant="caption">{label}</Typography>
        </Box>

        {badge && (
          <Chip
            label={badge.label}
            size="small"
            sx={{
              height: 18,
              fontSize: '0.5rem',
              bgcolor: badge.colour,
              color: '#fff',
            }}
          />
        )}
      </Box>

      <Typography
        sx={{
          color: colour,
          fontWeight: 700,
          mt: 1,
        }}
      >
        {`${percentage}%`}
      </Typography>

      <Typography variant="caption">
        {displayValue} / {displayTarget}
      </Typography>
    </Card>
  )
}

FitnessStatTile.propTypes = {
  label: PropTypes.string.isRequired,
  colour: PropTypes.string.isRequired,
  data: metricDataPropType.isRequired,
}
